// API Configuration - Force production for now
export const API_BASE_URL = 'https://pronostika-platform-production.up.railway.app';
export const SOCKET_URL = 'https://pronostika-platform-production.up.railway.app';